/* tslint:disable */
/* eslint-disable */
/**
 * Melco Tracking APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackingTrackingModelsAnalyticsDownloadDailySummary
 */
export interface TrackingTrackingModelsAnalyticsDownloadDailySummary {
    /**
     * 
     * @type {Date}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    date?: Date;
    /**
     * 
     * @type {number}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    unique_files?: number;
    /**
     * 
     * @type {number}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    total_files?: number;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    last_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    product_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    melco_customer_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TrackingTrackingModelsAnalyticsDownloadDailySummary
     */
    type?: string | null;
}

export function TrackingTrackingModelsAnalyticsDownloadDailySummaryFromJSON(json: any): TrackingTrackingModelsAnalyticsDownloadDailySummary {
    return TrackingTrackingModelsAnalyticsDownloadDailySummaryFromJSONTyped(json, false);
}

export function TrackingTrackingModelsAnalyticsDownloadDailySummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackingTrackingModelsAnalyticsDownloadDailySummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'unique_files': !exists(json, 'unique_files') ? undefined : json['unique_files'],
        'total_files': !exists(json, 'total_files') ? undefined : json['total_files'],
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'product_code': !exists(json, 'product_code') ? undefined : json['product_code'],
        'melco_customer_id': !exists(json, 'melco_customer_id') ? undefined : json['melco_customer_id'],
        'type': !exists(json, 'type') ? undefined : json['type'],
    };
}

export function TrackingTrackingModelsAnalyticsDownloadDailySummaryToJSON(value?: TrackingTrackingModelsAnalyticsDownloadDailySummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date === undefined ? undefined : (value.date.toISOString()),
        'unique_files': value.unique_files,
        'total_files': value.total_files,
        'user_name': value.user_name,
        'first_name': value.first_name,
        'last_name': value.last_name,
        'id': value.id,
        'product_code': value.product_code,
        'melco_customer_id': value.melco_customer_id,
        'type': value.type,
    };
}


